import Vue from 'vue'
import Router from 'vue-router'

// Dashboard Components
import dashboard from '../views/dashboard'

//  Widgets Components
import mainView from '../mainView'

import buttons from '../views/basic-elements/buttons'
import campaigns from '../views/basic-elements/campaigns'
import campaignDetails from '../views/basic-elements/campaignDetail'
import campaignStatus from '../views/basic-elements/campaignStatus'
import settings from '../views/basic-elements/settings'
import users from '../views/basic-elements/users'
import logs from '../views/basic-elements/logs'
import dropdowns from '../views/basic-elements/dropdowns'
import typography from '../views/basic-elements/typography'

//  Chart Components
import chartjs from '../views/charts/chartjs'

//  Icons Components
import mdiIcons from '../views/icons/mdi-icons'

import login from '../views/samples/user-pages/login'
import register from '../views/samples/user-pages/register'
import store from '../store'
//  Table Components
import basicTables from '../views/tables/basic-table'

Vue.use(Router)

const ifAuthenticated = (to, from, next) => {
  try {
    console.log(store.state.user.loggedIn)
    if (store.state.user.loggedIn) {
      console.log('User is logged in! Redirecting to desired page')
      next()
    } else {
      console.log('INTRUDER DETECTED!!')
      next('/login')
    }
  } catch (ex) {
    console.log(ex)
    next('/login')
  }
}

export default new Router({
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  mode: 'hash',
  routes: [{
    path: '/',
    redirect: '/campagnes',
    component: mainView,
    beforeEnter: ifAuthenticated,
    home: false,
    callback: false,
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: dashboard
      },
      {
        path: '/campagnes',
        name: 'campagnes',
        component: campaigns
      },
      {
        path: '/campaign/:campaignId',
        name: 'campaignDetail',
        component: campaignDetails,
        props: true
      },
      {
        path: '/campaignstatus/:campaignId',
        name: 'campaignStatus',
        component: campaignStatus,
        props: true
      },
      {
        path: '/instellingen/',
        name: 'Instellingen',
        component: settings
      },
      {
        path: '/users',
        name: 'Users',
        component: users
      },
      {
        path: '/logs',
        name: 'Logs',
        component: logs
      },
      {
        path: '/buttons',
        name: 'buttons',
        component: buttons
      },
      {
        path: '/dropdowns',
        component: dropdowns
      },
      {
        path: '/typography',
        component: typography
      },
      {
        path: '/chartjs',
        component: chartjs
      },
      {
        path: '/mdiIcons',
        component: mdiIcons
      },
      {
        path: '/basic_table',
        name: 'basicTables',
        component: basicTables
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '*',
    redirect: '/pages/error_404',
    component: {
      render (c) { return c('router-view') }
    },
    children: [
      {
        path: '/pages/login',
        name: 'login',
        component: login
        // beforeEnter: ifNotAuthenticated
      },
      {
        path: '/pages/register',
        component: register
        // beforeEnter: ifNotAuthenticated
      }
    ]}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js